"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeToConfirmations = void 0;
const retry_1 = require("./retry");
exports.subscribeToConfirmations = (promiEvent, cancelled, getConfirmations) => {
    let mutex;
    const watchForConfirmations = async () => {
        const lock = Symbol();
        mutex = lock;
        // Yield to task manager to let the event subscription finish
        await retry_1.sleep(0);
        let confirmations = 0;
        while (!cancelled() && watchingConfirmations && mutex === lock) {
            try {
                const newConfirmations = await getConfirmations();
                if (newConfirmations > confirmations) {
                    confirmations = newConfirmations;
                    promiEvent.emit("confirmation", confirmations);
                }
            }
            catch (error) {
                console.error(error);
            }
            await retry_1.sleep(5000);
        }
    };
    let watchingConfirmations = 0;
    promiEvent.on("newListener", (eventName) => {
        if (eventName === "confirmation") {
            watchingConfirmations++;
            if (watchingConfirmations === 1) {
                watchForConfirmations();
            }
        }
    });
    promiEvent.on("removeListener", (eventName) => {
        if (eventName === "confirmation") {
            watchingConfirmations--;
        }
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlybWF0aW9ucy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvY29uZmlybWF0aW9ucy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFDQSxtQ0FBZ0M7QUFFbkIsUUFBQSx3QkFBd0IsR0FBRyxDQUNwQyxVQUF5QixFQUN6QixTQUF3QixFQUN4QixnQkFBdUMsRUFDekMsRUFBRTtJQUNBLElBQUksS0FBSyxDQUFDO0lBQ1YsTUFBTSxxQkFBcUIsR0FBRyxLQUFLLElBQUksRUFBRTtRQUNyQyxNQUFNLElBQUksR0FBRyxNQUFNLEVBQUUsQ0FBQztRQUN0QixLQUFLLEdBQUcsSUFBSSxDQUFDO1FBRWIsNkRBQTZEO1FBQzdELE1BQU0sYUFBSyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBRWYsSUFBSSxhQUFhLEdBQUcsQ0FBQyxDQUFDO1FBQ3RCLE9BQU8sQ0FBQyxTQUFTLEVBQUUsSUFBSSxxQkFBcUIsSUFBSSxLQUFLLEtBQUssSUFBSSxFQUFFO1lBQzVELElBQUk7Z0JBQ0EsTUFBTSxnQkFBZ0IsR0FBRyxNQUFNLGdCQUFnQixFQUFFLENBQUM7Z0JBQ2xELElBQUksZ0JBQWdCLEdBQUcsYUFBYSxFQUFFO29CQUNsQyxhQUFhLEdBQUcsZ0JBQWdCLENBQUM7b0JBQ2pDLFVBQVUsQ0FBQyxJQUFJLENBQUMsY0FBYyxFQUFFLGFBQWEsQ0FBQyxDQUFDO2lCQUNsRDthQUNKO1lBQUMsT0FBTyxLQUFLLEVBQUU7Z0JBQ1osT0FBTyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsQ0FBQzthQUN4QjtZQUNELE1BQU0sYUFBSyxDQUFDLElBQUksQ0FBQyxDQUFDO1NBQ3JCO0lBQ0wsQ0FBQyxDQUFDO0lBRUYsSUFBSSxxQkFBcUIsR0FBRyxDQUFDLENBQUM7SUFDOUIsVUFBVSxDQUFDLEVBQUUsQ0FBQyxhQUFhLEVBQUUsQ0FBQyxTQUFTLEVBQUUsRUFBRTtRQUN2QyxJQUFJLFNBQVMsS0FBSyxjQUFjLEVBQUU7WUFDOUIscUJBQXFCLEVBQUUsQ0FBQztZQUN4QixJQUFJLHFCQUFxQixLQUFLLENBQUMsRUFBRTtnQkFDN0IscUJBQXFCLEVBQUUsQ0FBQzthQUMzQjtTQUNKO0lBQ0wsQ0FBQyxDQUFDLENBQUM7SUFFSCxVQUFVLENBQUMsRUFBRSxDQUFDLGdCQUFnQixFQUFFLENBQUMsU0FBUyxFQUFFLEVBQUU7UUFDMUMsSUFBSSxTQUFTLEtBQUssY0FBYyxFQUFFO1lBQzlCLHFCQUFxQixFQUFFLENBQUM7U0FDM0I7SUFDTCxDQUFDLENBQUMsQ0FBQztBQUNQLENBQUMsQ0FBQyJ9